import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actionCreators } from "../redux/noVisitAfterFirstVisitSagas";

export const UpdateButtons = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.noVisitAfterFirstVisit.filtersDirty);

  return filtersDirty ? (
    <>
      <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
        Update
      </button>

      <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
        Reset
      </button>
    </>
  ) : (
    ""
  );
};
